<template>
  <div>
    <PCNavbar selectIndex="6-1" />
    <MobileNavBar :currentActive="5" />
    <div class="warp">
      <div class="enter_innovation_wrap">
        <div class="enter_img">
          <div class="img_tit hidden-xs-only">论文</div>
          <div class="img_tit hidden-sm-and-up">论文</div>
        </div>
      </div>
      <div class="card_wrap">
        <div
          class="brain_item"
          v-for="(item, index) in cardList"
          :key="index"
          @click="handleNavigate(item.path)"
        >
          <div class="item_title">
            <img :src="item.img" alt="" />
          </div>
          <div class="item_desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data() {
    return {
      cardList: [
        {
          img: require("@/assets/lun1.webp"),
          desc: "氢能发展论文",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun2.webp"),
          desc: "能景研究论文",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun3.webp"),
          desc: "氢能产业蓝图",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun4.webp"),
          desc: "拥抱氢能，未来可期",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun1.webp"),
          desc: "氢能发展论文",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun2.webp"),
          desc: "能景研究论文",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun3.webp"),
          desc: "氢能产业蓝图",
          path: "/news/news",
        },
        {
          img: require("@/assets/lun4.webp"),
          desc: "拥抱氢能，未来可期",
          path: "/news/news",
        },
      ],
    };
  },
  methods: {
    handleNavigate(path) {
      window.open(window._CONFIG["baseUrl"] + "/qing.pdf");
    },
  },
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/lunwen.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
  }
}
.card_wrap {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 90%;
    display: block;
  }
  .brain_item {
    width: 22%;
    padding: 30px;
    cursor: pointer;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
    margin-top: 50px;
    position: relative;
    transition: all 0.5s;
    &:hover {
      transform: translateY(-8px);
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      font-size: 0.8rem;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 40px;
    }
    .item_title {
      position: inherit;
      padding: 20px 0 40px 0;
      z-index: 2;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      img {
        width: 100%;
        height: 250px;
        object-fit: cover;
      }
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
        img {
          width: 100%;
          height: 250px;
          object-fit: cover;
        }
      }
    }
    .item_desc {
      transition: all 0.5s;
      color: #000;
      text-align: center;
      line-height: 1.5rem;
      z-index: 2;
      position: inherit;
      font-size: 22px;
      margin-bottom: 10px;
      font-weight: 700;
      @media screen and (max-width: 768px) {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
}
</style>